import React from 'react'
import Modal from '../common/Modal'
import { useMutation } from '@tanstack/react-query'
import { handlePostRequest } from '../../utils/api-handler.util'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import { useFileUpload } from '../../hooks/useFileUpload'
import LoadingIcon from '../icons/LoadingIcon'

const AddPromotionModal = ({ isOpen, onClose }) => {
  const { renderUploadInput, handleFileUpload, isUploading } = useFileUpload({
    label: 'Upload Banner',
    dropZoneOptions: {
      multiple: false,
      accept: {
        'image/*': ['.jpg', '.jpeg', '.png', '.webp'],
      },
    },
  })
  const [promotion, updatePromotion] = React.useReducer(
    (state, newState) => ({ ...state, ...newState }),
    { banner: null, link: '', preview: null }
  )

  const createPromotionMutation = useMutation({
    mutationFn: async ({ bannerImage, link }) => {
      return handlePostRequest('/admins/promotions', { bannerImage, link })
    },
    onSuccess: () => {
      QueryKeys.adminListPromotions.invalidateAll()
      handleCancel()
    },
  })

  const handleSubmit = async (e) => {
    e.preventDefault()
    const fileUrl = await handleFileUpload()

    if (!fileUrl) return

    await createPromotionMutation.mutateAsync({ bannerImage: fileUrl, link: promotion.link })
  }

  const handleCancel = () => {
    updatePromotion({ banner: null, link: '', preview: null })
    onClose()
  }

  const isButtonBusy = () => createPromotionMutation.isLoading || isUploading

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="flex items-center flex-col gap-4">
        <h2 className="text-2xl font-semibold  mb-8">Add Promotion</h2>
        <form onSubmit={handleSubmit} className="flex flex-col space-y-6 w-full px-5">
          <div className="w-full">{renderUploadInput()}</div>
          <div className="w-full">
            <label htmlFor="link" className="block text-lg font-medium text-black mb-1">
              Link
            </label>
            <input
              id="link"
              name="link"
              type="text"
              className="w-full border border-gray-300 rounded px-3 py-2 bg-secondary-50 focus:outline-none focus:ring-2 focus:ring-secondary-600"
              value={promotion.link}
              onChange={(e) => updatePromotion({ link: e.target.value })}
              placeholder="https://..."
              required
            />
          </div>
          <div className="grid grid-cols-2 gap-4 mt-8">
            <button
              type="button"
              onClick={handleCancel}
              className="py-2 rounded-[10px] bg-neutral-200-400 text-white text-lg font-medium capitalize hover:bg-neutral-200-500 transition"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="py-2 rounded-[10px] bg-secondary-600 text-white text-lg font-medium capitalize hover:bg-orange-700 transition"
              disabled={isButtonBusy()}
            >
              {isButtonBusy() ? (
                <>
                  <LoadingIcon />
                  Creating...
                </>
              ) : (
                'Create'
              )}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  )
}

export default AddPromotionModal
